<template>
    <main class="main">
        <div class="container">
            <header-tabs
                class="user-settings-nav mt-3 has-icons"
                :content="headerTabs"
                :activeTab="activeTab"
            />
            <template v-if="$route.name === 'settings'">
                <the-settings />
            </template>
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
import TheSettings from '../components/settings/TheSettings.vue'

export default {
    components: {
        TheSettings
    },
    data() {
        return {
            user: {
                name: '',
                surname: '',
                tel: ''
            },
            passwords: {
                oldPassword: '',
                newPassword: '',
                repeatNewPassword: ''
            },
            invalidRepeat: false
        }
    },
    computed: {
        headerTabs() {
            return this.$store.getters.getUserNav.map(({ icon, ...rest }) => rest)
        },
        activeTab: {
            get() {
                return this.$store.getters.getUserActiveTab
            },
            set(value) {
                this.$store.dispatch('setUserActiveTab', value)
            }
        }
    }
}
</script>

<style lang="scss">
@import '../styles/custom.scss';
@import '~bootstrap/scss/mixins';

.user-settings-nav {
    .nav {
        width: 100%;
    }

    .nav-link {
        flex-direction: column;
        padding: 0.75rem 0.5rem;
        font-size: 0.75rem;
        justify-content: center;

        span {
            margin-left: 0;
        }

        @media (min-width: 1400px) {
            padding: 0.7rem 1.5rem;
            flex-direction: row;
            font-size: 1rem;

            span {
                margin-left: 0.25rem;
            }
        }
    }
}
</style>
